export default __webpack_public_path__ + "static/media/IcArrowRightActive.2a88bfae.svg";